import { Box, Modal } from "@mui/material";
import { BrandButton } from "./form/buttons";

interface Props {
  open: boolean;
}

const NetworkError = ({ open }: Props) => {
  const gotoLoginScreen = () => {
    if (process.env && process.env.NODE_ENV === "development") {
      // in dev mode, just reload the page
      window.location.href = "/#/";
    } else {
      // in production, redirect to login
      window.location.href = "diagnostic/";
    }
  };

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        className="expiredModalContent"
        style={{ backgroundColor: "#ff0000", color: "#fff" }}
      >
        <div className="header">Network Error</div>
        <p>
          {" "}
          There was a problem communicating with the application server. Please
          notify the administrator.
        </p>
        <div>
          <BrandButton onClick={gotoLoginScreen}>
            Click here to login
          </BrandButton>
        </div>
      </Box>
    </Modal>
  );
};
export default NetworkError;
